<template>
  <div class="rank-list">
    <div class="title-1" style="margin-bottom: 15px">{{ title }}</div>
    <template v-if="dataSource.length">
      <div
        v-for="(item, index) in dataSource"
        :key="index"
        class="rank-item flex-between"
        :style="{
          backgroundColor: isAsc ? '#f0fdf4' : '#FEF2F2',
        }"
      >
        <div class="left-area flex-align-center">
          <div class="rank flex-center" :style="{ backgroundColor: isAsc ? '#02b8d9' : '#F53F3F' }">
            {{ index + 1 }}
          </div>
          <div class="class-name">{{ item.className }}</div>
        </div>
        <div class="flex-align-center">
          <div>{{ item.avgValue }}</div>
          <a-icon :type="isAsc ? 'arrow-up' : 'arrow-down'" style="margin: 0 6px" />
          <div :style="{ color: isAsc ? '#3BA1F5  ' : '#FF3535' }">{{ item.diffValue }}</div>
        </div>
      </div>
    </template>
    <!--空数据-->
    <EmptyData v-else />
  </div>
</template>
<script>
export default {
  name: 'RankList',
  props: {
    title: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    // 是否上升
    isAsc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {}
  },
}
</script>
<style scoped lang="less">
.rank-list {
  .rank-item {
    box-sizing: border-box;
    height: 50px;
    padding: 0 20px;
    border-radius: 10px;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
    .left-area {
      .rank {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        color: #fff;
      }
      .class-name {
        margin-left: 13px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
</style>
